import "./stylesVerificationEmailModal.css";

import { CloseOutlined } from "@ant-design/icons";

import { AppStrings } from "../../../../../utils/constants/AppStrings";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { message } from "antd";
import { useState } from "react";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

function VerificationEmailModal({ handleCancel, data }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken
  );

  const [isApiRunning, setIsApiRunning] = useState(false);

  const onCancel = () => {
    handleCancel();
  };

  const onSend = async () => {
    setIsApiRunning(true);
    const params = {
      user_id: data?.user_id,
      email: data?.email,
    };

    try {
      await PrivateAdminPanelInstance?.post(
        API_ROUTES?.SEND_EMAIL_VERIFICATION,
        params
      );

      message.success(AppStrings.EMAIL_VERIFICATION_SENT_SUCCESSFULLY);
    } catch (error) {
      console.log("error sending email verification code", error?.response);
      message.error(AppStrings.ERROR_PROCESSING_REQUEST);
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className="verification-email-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">
            {AppStrings.SEND_VERIFICATION_EMAIL}
          </h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <div className="verification-email-message">
          <span>{AppStrings.SEND_VERIFICATION_EMAIL_MESSAGE}</span>
        </div>
      </div>
      <div className="modal-footer">
        <div className="buttons">
          <button className="cancel-button" onClick={onCancel}>
            {AppStrings.CLOSE}
          </button>
          <button className="save-button" onClick={onSend} disabled={isApiRunning}>
            {isApiRunning ? (
              <RebetLoader height={"50px"} width={"50px"} />
            ) : (
              AppStrings.SEND
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default VerificationEmailModal;
